var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Transforms } from "slate";
import { useSlateStatic, ReactEditor, useSelected, useFocused, } from "slate-react";
import { css } from "@emotion/css";
import { Button, Icon } from "../BaseComponents";
var HorizontalElement = function (props) {
    var attributes = props.attributes, children = props.children, element = props.element;
    var editor = useSlateStatic();
    var path = ReactEditor.findPath(editor, element);
    var selected = useSelected();
    var focused = useFocused();
    return (_jsxs("div", __assign({}, attributes, { children: [children, _jsxs("div", __assign({ contentEditable: false, className: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          position: relative;\n        "], ["\n          position: relative;\n        "]))) }, { children: [_jsx("hr", { className: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            border: none;\n            border-top: 2px solid #000;\n            cursor: pointer;\n          "], ["\n            border: none;\n            border-top: 2px solid #000;\n            cursor: pointer;\n          "]))) }), _jsx(Button, __assign({ active: true, onClick: function () { return Transforms.removeNodes(editor, { at: path }); }, className: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n            display: ", ";\n            position: absolute;\n            top: 0.5em;\n            left: 0.5em;\n            background-color: white;\n          "], ["\n            display: ", ";\n            position: absolute;\n            top: 0.5em;\n            left: 0.5em;\n            background-color: white;\n          "])), selected && focused ? "inline" : "none") }, { children: _jsx(Icon, { children: "delete" }) }))] }))] })));
};
export default HorizontalElement;
var templateObject_1, templateObject_2, templateObject_3;
